<template>
  <mdb-container>
    <div v-if="validPlans.length > 0">
      <h5>Subscription Plans</h5>
      <div v-if="memberPlans.length==0">
        {{member.name}} doesn't have any subscription plans assigned.
      </div>
      <mdb-tooltip :options="{placement: 'top'}" material trigger="hover">
        <span slot="tip">Add a Plan</span>
        <mdb-btn @click="addPlan" floating
                 type=""
                 icon="plus-circle" size="sm" slot="reference" tag="a"></mdb-btn>
      </mdb-tooltip>

      <mdb-tbl responsive v-if="memberPlans.length>0">
        <mdb-tbl-head>
          <tr>
            <th></th>
            <th>Plan</th>
            <th>Price</th>
            <th>Status</th>
            <th>Start</th>
            <th>End</th>
            <th>Due</th>
            <th>Reminder 1</th>
            <th>Reminder 2</th>
            <th>&nbsp;</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body v-bind:key="plan.id" v-for="plan in memberPlans">
          <td>
            <mdb-tooltip :options="{placement: 'top'}" material trigger="hover">
              <span slot="tip">Delete Plan</span>
              <mdb-btn @click="deletePlan(plan)" color="warning"
                       type=""
                       floating icon="trash" size="sm" slot="reference"
                       tag="a"></mdb-btn>
            </mdb-tooltip>
          </td>
          <td>{{plan.name}}</td>
          <td>{{plan.price}}</td>
          <td>{{plan.status}}</td>
          <td>{{plan.startDate}}</td>
          <td>{{plan.endDate}}
            <span v-if="plan.inGracePeriod"><br/><b><i>In grace period.</i></b></span>
          </td>
          <td>{{plan.dueDate}}</td>
          <td>{{plan.reminder1Due}}
            <i class="fal fa-check" v-if="plan.reminder1Sent"></i>
          </td>
          <td>{{plan.reminder2Due}}
            <i class="fal fa-check" v-if="plan.reminder2Sent"></i>
          </td>
          <td>
            <mdb-btn @click="planStatus(plan.id,'Active')" size="sm" v-if="plan.status == 'Pending' && plan.startDateIso <= defaultStartDate">Set to Active</mdb-btn>
            <mdb-btn @click="planStatus(plan.id,'Pending')" size="sm" v-if="plan.status == 'Active' && plan.endDateIso >= defaultStartDate">Set to Pending</mdb-btn>
          </td>
        </mdb-tbl-body>
      </mdb-tbl>


      <hr>
    </div>
    <div v-if="!createOnly">
      <h5>Transactions <span v-if="member.balance != 0">(Balance Due: {{member.balance}})</span></h5>
      <mdb-tooltip :options="{placement: 'top'}" material trigger="hover">
        <span slot="tip">Record a Transaction</span>
        <mdb-btn @click="addTransaction" floating icon="plus-circle" size="sm" slot="reference"
                 type=""
                 tag="a"></mdb-btn>
      </mdb-tooltip>
      <mdb-tbl responsive>
        <mdb-tbl-head>
          <tr>
            <th></th>
            <th>Date</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Source</th>
            <th>Confirmation</th>
            <th>Audit</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body v-bind:key="trans.id" v-for="trans in transactions">
          <td>
            <mdb-tooltip :options="{placement: 'right'}" material trigger="hover" v-if="trans.allowDelete">
              <span slot="tip">Delete this transaction </span>
              <mdb-btn @click="deleteTransaction(trans)" color="warning" floating icon="trash" size="sm"
                       slot="reference"
                       type=""
                       tag="a"></mdb-btn>
            </mdb-tooltip>
          </td>
          <td>{{trans.displayDate}}</td>
          <td>{{trans.description}}</td>
          <td>{{trans.amount}}</td>
          <td>{{trans.source}}</td>
          <td>{{trans.confirmationCode}}</td>
          <td>{{trans.recordedDate}} by {{trans.recordedBy}}</td>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <mdb-modal :show="controls.showAddPlan" @close="cancelAddPlan" info
               position="top-center"
               size="lg">
      <mdb-modal-header>
        <p class="heading">Add plan for {{member.name}}</p>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div class="md-form">
          <select class="material-input form-control"
                  id="planId"
                  v-model="newPlan.planId">
            <option :value="opt.id" v-for="opt in validPlans">{{opt.name}} ({{opt.price}})</option>
          </select>
          <label class="active mr-5">Plan</label>
        </div>

        <div class="md-form">
          <div>
            <datetime :format="userDetails.dateFormat"
                      :valueZone="userDetails.timezone"
                      :auto="true"
                      :weekStart="userDetails.mondayFirst ? 1 : 7" v-model="newPlan.startDate">
            </datetime>

            <label class="active mr-5">Start Date</label>
          </div>
        </div>
        <mdb-btn @click="saveNewPlan" icon="save" v-if="newPlan.startDate && newPlan.planId">Save</mdb-btn>
        <mdb-btn @click="cancelAddPlan" icon="ban">Cancel Add</mdb-btn>

      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal :show="controls.showDeleteConfirm" @close="controls.showDeleteConfirm = false" class="text-center"
               danger size="sm" v-if="controls.showDeleteConfirm">
      <mdb-modal-header :close="false" center>
        <p class="heading">Are you sure you wish to delete this record?</p>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-icon class="animated rotateIn" icon="times" size="4x"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click="doDelete" outline="danger">Yes</mdb-btn>
        <mdb-btn @click="controls.showDeleteConfirm = false">No</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-modal :show="controls.showEditTransaction" @close="cancelTransaction" class="animated" info
               position="top-center" size="lg"
               v-if="controls.showEditTransaction">
      <mdb-modal-header>
        <p class="heading">Add transaction for {{member.name}}</p>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <div class="md-form">
          <div>
            <datetime :format="userDetails.dateFormat"
                      :valueZone="userDetails.timezone"
                      :auto="true"
                      :weekStart="userDetails.mondayFirst ? 1 : 7" v-model="editingTransaction.date">
              :zone="userDetails.timezone" :format="userDetails.dateFormat">
            </datetime>
            <label class="active mr-5">Date</label>
          </div>
        </div>

        <mdb-input type="text" v-model="editingTransaction.description" placeholder="Transaction description. Optional." label="Description"></mdb-input>
        <mdb-input type="number" :step="0.01" :separator="userDetails.decimalSeparator" minus  v-model="editingTransaction.amount" label="Amount" placeholder="Amount"></mdb-input>
        <div class="md-form">
          <select class="material-input form-control"
                  id="drCr"
                  v-model="editingTransaction.drCr">
            <option value="CR">Payment (Credit)</option>
            <option value="DR">Charge/Refund (Debit)</option>
          </select>
          <label class="active mr-5">Payment or Charge</label>
        </div>
        <mdb-input type="text" v-model="editingTransaction.confirmationCode" label="Confirmation"
                   placeholder="Enter optional confirmation code, check number, etc."></mdb-input>


        <div class="md-form">
          <select class="material-input form-control"
                  id="transId"
                  v-model="editingTransaction.source">
            <option :value="opt" v-for="opt in sources">{{opt}}</option>
          </select>
          <label class="active mr-5">Source</label>
        </div>

        <mdb-btn @click="saveTransaction" icon="save" v-if="editingTransaction.date && editingTransaction.amount">Save</mdb-btn>
        <mdb-btn @click="cancelTransaction" icon="ban">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {Datetime} from 'vue-datetime'
import moment from 'moment'
import {
  mdbBtn,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip
} from 'mdbvue';
import {mapState} from "vuex";

export default {
    name: 'Member-Billing',
    components: {
      mdbBtn,
      mdbContainer,
      mdbTbl,
      mdbTblHead,
      mdbTblBody,
      mdbTooltip,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter,
      mdbIcon,
      mdbInput,
      Datetime
    },
    props: {
      member: {
        type: Object,
        default: null
      },
      group: {
        type: Object,
        default: null
      },
      createOnly: {
        type: Boolean,
        default: false
      }
    },
    computed: mapState({userDetails: state => state.userDetails}),
    data() {
      return {
        transactions: [],
        editingTransaction: {},
        validPlans: [],
        memberPlans: [],
        newPlan: {},
        defaultStartDate: null,
        sources: ["Check", "Cash", "Credit Card", "PayPal", "Stripe", "Venmo", "Other", "Adjustment"],
        controls: {
          showAddPlan: false,
          showEditTransaction: false,
          showDeleteConfirm: false,
          deleteRequested: null,
          deleteObj: null
        }
      }
    },
    mounted() {
      if (this.createOnly) {
        this.defaultStartDate = moment().format()
        this.addTransaction()
        return
      }
      api.get("/member/plans/" + this.group.vanityPath + "/?member=" + this.member.id).then(
        (results) => {
          this.memberPlans = results.data.memberPlans
          this.validPlans = results.data.validPlans
          this.defaultStartDate = results.data.defaultStartDate
        },
        (error) => {
          this.$notify.error({message: "Error fetching data", timeOut: 5000})
        })
      this.loadTransactions()
    },
    methods: {
      planStatus(id, status) {
        api.post("/member/planStatus/" + this.group.vanityPath, {plan: id, status: status} ).then(
          (results) => {
            for (const mp of this.memberPlans) {
              if (mp.id == id) mp.status = status
            }
          },
          (error) => {
            this.$notify.error({message: "Error fetching data", timeOut: 5000})
          })
      },
      loadTransactions() {
        api.get("/member/transactions/" + this.group.vanityPath + "/?member=" + this.member.id).then(
          (results) => {
            this.transactions = results.data.transactions
            this.member.balance = results.data.balance
          },
          (error) => {
            this.$notify.error({message: "Error fetching data", timeOut: 5000})
          })
      },
      addPlan() {
        this.newPlan = {planId: null, startDate: this.defaultStartDate}
        //this.newPlan = {planId: null, startDate: null}
        this.controls.showAddPlan = true
      },
      cancelAddPlan() {
        this.controls.showAddPlan = false
      },
      deletePlan(plan) {
        this.controls.deleteObj = plan
        this.controls.deleteRequested = "plan"
        this.controls.showDeleteConfirm = true
      },
      deleteTransaction(trans) {
        this.controls.deleteObj = trans
        this.controls.deleteRequested = "trans"
        this.controls.showDeleteConfirm = true
      },
      doDelete() {
        this.controls.showDeleteConfirm = false
        if (this.controls.deleteRequested == "plan") {
          api.delete("/member/subscription/" + this.group.vanityPath + "/?member=" + this.member.id +
                       '&subscriptionId=' + this.controls.deleteObj.id).then(
            (results) => {
              let loc = this.memberPlans.indexOf(this.controls.deleteObj)
              console.log("Deleting plan",this.controls.deleteObj, "LOC", loc)
              this.memberPlans.splice(loc, 1)
              this.loadTransactions()
            },
            (error) => {
              this.$notify.error({message: "Error deleting record.", timeOut: 5000})
            }).then(() => {
            this.$store.dispatch("setExecuting", false)
          })
        }
        if (this.controls.deleteRequested == "trans") {
          api.delete("/member/transaction/" + this.controls.deleteObj.id).then(
            (results) => {
              this.loadTransactions()
            },
            (error) => {
              this.$notify.error({message: "Error deleting record.", timeOut: 5000})
            }).then(() => {
            this.$store.dispatch("setExecuting", false)
          })
        }
      },
      saveNewPlan() {
        this.controls.showAddPlan = false
        this.$store.dispatch("setExecuting", true)
        api.put("/member/subscription/" + this.group.vanityPath + "/?member=" + this.member.id,
                {planId: this.newPlan.planId, startDate: this.newPlan.startDate}).then(
          (results) => {
            this.memberPlans.push(results.data)
            this.loadTransactions()
          },
          (error) => {
            this.$notify.error({message: "Error fetching data", timeOut: 5000})
            this.controls.showAddPlan = true
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      },
      addTransaction() {
        this.editingTransaction = {
          allowDelete: false
          , amount: null
          , confirmationCode: ""
          , date: this.defaultStartDate
          , description: ""
          , displayDate: ""
          , source: ""
          , drCr: "CR"
          , id: null
        }
        this.controls.showEditTransaction = true
      },
      saveTransaction() {
        this.controls.showEditTransaction = false
        if (this.editingTransaction.drCr == "CR") this.editingTransaction.amount = this.editingTransaction.amount *-1
        this.$store.dispatch("setExecuting", true)
        api.put("/member/transaction/" + this.member.id,
                this.editingTransaction).then(
          (results) => {
            if (this.createOnly) {
              this.$emit("transactionSaved", results.data)
            }
            else {
              this.member.balance = results.data.balance
              this.transactions.unshift(results.data.transaction)
            }
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 8000})
            this.controls.showEditTransaction = true
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      cancelTransaction() {
        this.controls.showEditTransaction = false
        if (this.createOnly) {
          this.$emit("transactionCanceled")
        }
      },

    }
  };
</script>
<style scoped>
  .material-input {
    box-sizing: content-box;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
    outline: none;
    box-shadow: none;
  }
</style>
<style lang="scss">
  @import '~vue-datetime/dist/vue-datetime.min';
</style>
